var r={WorkItem:"11",WorkItemTask:"12"};export{r as NotificationType};
